(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-two-col"] && !window.DesignMode) return;
  try {
    
var seeMore = document.querySelector('.see-more-mobile');
    seeMore.addEventListener("click", function () {
         this.parentElement.classList.toggle('show-more');
           
});

var seeMore = document.querySelector('.show-more-desktop');
    seeMore.addEventListener("click", function () {
         this.parentElement.classList.toggle('show-more');          
});

var accordionTitles = document.querySelectorAll(".faq-list__item");
      accordionTitles.forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
      if (accordionTitle.classList.contains("is-open")) {
        accordionTitle.classList.remove("is-open");
      } else {
      var accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
      accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
        accordionTitleWithIsOpen.classList.remove("is-open");
      });
      accordionTitle.classList.add("is-open");
    }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
document.querySelector(".slider-icons .swiper-button-prev").addEventListener("click", function(){
    document.querySelector(".category_collection_product swiper-slider .swiper-button-prev").click();
})

document.querySelector(".slider-icons .swiper-button-next").addEventListener("click", function(){
    document.querySelector(".category_collection_product swiper-slider .swiper-button-next").click();
  
})

  } catch(e) { console.error(e); }
})();
})();
